import PropTypes from 'prop-types';

import { Button } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import GenericFormContainer from '../../Forms/GenericFormContainer';

import { lengthValidation1000, required } from '../../Forms/utils';

import { STYLED_TEXT } from '../../Forms/fieldTypes';

const CommunityMessageSellerFormComponent = (props) => {
  const { t } = useTransl();
  const { form, onMessageSubmit, initialValues, onModalClose } = props;

  const formData = [
    {
      keyName: 'subject',
      label: t('title.subject'),
      fieldType: STYLED_TEXT,
      validate: [],
      disabled: true,
    },
    {
      keyName: 'text',
      label: t('title.message'),
      fieldType: STYLED_TEXT,
      multiline: true,
      minRows: 3,
      validate: [required, lengthValidation1000],
    },
  ];

  const CancelButton = () => (
    <Button
      type="cancel"
      variant="contained"
      color="inherit"
      disableElevation
      onClick={onModalClose}
    >
      {t('actions.cancel')}
    </Button>
  );

  return (
    <GenericFormContainer
      form={form}
      formData={formData}
      onSubmit={onMessageSubmit}
      submitText={t('actions.send')}
      initialValues={initialValues}
      disabled={false}
      backButton={false}
      CustomComponent={CancelButton}
      isFullWidthForm
      enableReinitialize
    />
  );
};

CommunityMessageSellerFormComponent.defaultProps = {
  initialValues: null,
};

CommunityMessageSellerFormComponent.propTypes = {
  form: PropTypes.string.isRequired,
  onMessageSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.instanceOf(Object),
  onModalClose: PropTypes.func.isRequired,
};

export default CommunityMessageSellerFormComponent;
